/**
 * @file iconMap.ts
 * @description Registry of available SVG icons with dynamic imports for code splitting.
 * Icons are lazy-loaded only when used, reducing initial bundle size.
 */

import dynamic from 'next/dynamic';

/**
 * Map of icon names to dynamically imported SVG components.
 * Used by SvgIcon component to resolve icon by name.
 */
export const iconMap = {
  'arrow-left': dynamic(() => import('./icons/icon--arrow-left')),
  'arrow-right': dynamic(() => import('./icons/icon--arrow-right')),
  'chevron-down': dynamic(() => import('./icons/icon--chevron-down')),
  'chevron-up': dynamic(() => import('./icons/icon--chevron-up')),
  close: dynamic(() => import('./icons/icon--close')),
  'menu-close': dynamic(() => import('./icons/icon--menu-close')),
  download: dynamic(() => import('./icons/icon--download')),
  'file-download': dynamic(() => import('./icons/icon--file-download')),
  facebook: dynamic(() => import('./icons/icon--facebook')),
  'hamburger-menu': dynamic(() => import('./icons/icon--hamburger-menu')),
  instagram: dynamic(() => import('./icons/icon--instagram')),
  magnifier: dynamic(() => import('./icons/icon--magnifier')),
  'new-tab': dynamic(() => import('./icons/icon--new-tab')),
  'new-window': dynamic(() => import('./icons/icon--new-window')),
  'no-image': dynamic(() => import('./icons/icon--no-image')),
  'outline-search': dynamic(() => import('./icons/icon--outline-search')),
  pause: dynamic(() => import('./icons/icon--pause')),
  pinterest: dynamic(() => import('./icons/icon--pinterest')),
  play: dynamic(() => import('./icons/icon--play')),
  'play-control': dynamic(() => import('./icons/icon--play-control')),
  plus: dynamic(() => import('./icons/icon--plus')),
  refine: dynamic(() => import('./icons/icon--refine')),
  sorting: dynamic(() => import('./icons/icon--sorting')),
  tiktok: dynamic(() => import('./icons/icon--tiktok')),
  youtube: dynamic(() => import('./icons/icon--youtube')),
  share: dynamic(() => import('./icons/icon--share')),
  'share-close': dynamic(() => import('./icons/icon--share-close')),
  'chevron-right': dynamic(() => import('./icons/icon--chevron-right')),
  'chevron-left': dynamic(() => import('./icons/icon--chevron-left')),
  checkmark: dynamic(() => import('./icons/icon--checkmark')),
  'arrow-dash-right': dynamic(() => import('./icons/icon--arrow-dash-right')),
  'alert-neutral': dynamic(() => import('./icons/icon--alert-neutral')),
  'alert-priority': dynamic(() => import('./icons/icon--alert-priority')),
  'accordion-plus': dynamic(() => import('./icons/icon--accordion-plus')),
  'accordion-minus': dynamic(() => import('./icons/icon--accordion-minus')),
  'arrow-dash-left': dynamic(() => import('./icons/icon--arrow-dash-left')),
  'video-play': dynamic(() => import('./icons/icon--video-play')),
  loading: dynamic(() => import('./icons/icon--loading')),
  'arrow-down': dynamic(() => import('./icons/icon--arrow-down')),
  'filter-lines': dynamic(() => import('./icons/icon--filter-lines')),
  'chevron-expand': dynamic(() => import('./icons/icon--chevron-expand')),
  'chevron-contract': dynamic(() => import('./icons/icon--chevron-contract')),
  'carousel-arrow-left': dynamic(() => import('./icons/icon--carousel-arrow-left')),
  'carousel-arrow-right': dynamic(() => import('./icons/icon--carousel-arrow-right')),
  'carousel-pause': dynamic(() => import('./icons/icon--carousel-pause')),
  'carousel-play': dynamic(() => import('./icons/icon--carousel-play')),
  'carousel-pagedot': dynamic(() => import('./icons/icon--carousel-pagedot')),
  'carousel-active-pagedot': dynamic(() => import('./icons/icon--carousel-active-pagedot')),
  'tag-close': dynamic(() => import('./icons/icon--tag-close')),
  'icon-steps-arrow-right': dynamic(() => import('./icons/icon--arrow-steps-right')),
};

/** Type-safe keys for available icons */
export type IconMapKeys = keyof typeof iconMap;
